import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from './ui/dialog';
import { Button } from './ui/button';
import { Home, ExternalLink } from 'lucide-react';

const PropertyPreviewDialog = ({ open, onOpenChange, propertyId, propertyTitle, propertySlug }) => {
  if (!propertyId && !propertySlug) return null;
  const url = `/property/${propertySlug || propertyId}`;
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className="max-w-6xl w-[95vw] h-[90vh] p-0 overflow-hidden flex flex-col"
        data-testid="property-preview-dialog"
      >
        <DialogHeader className="px-5 py-3 border-b flex-row items-center justify-between gap-3 space-y-0">
          <DialogTitle className="flex items-center gap-2 text-base">
            <Home className="h-4 w-4 text-[#7CB342]" />
            {propertyTitle || 'Property Preview'}
          </DialogTitle>
          <Button
            asChild
            variant="outline"
            size="sm"
            className="mr-8"
          >
            <a href={url} target="_blank" rel="noopener noreferrer">
              <ExternalLink className="h-3.5 w-3.5 mr-1.5" /> Open in new tab
            </a>
          </Button>
        </DialogHeader>
        <iframe
          title={propertyTitle || 'Property Preview'}
          src={url}
          className="flex-1 w-full border-0"
          data-testid="property-preview-iframe"
        />
      </DialogContent>
    </Dialog>
  );
};

export default PropertyPreviewDialog;
